import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authSlice from './slices/authSlice';
import notificationsSlice from './slices/notificationsSlice';
import uiSlice from './slices/uiSlice';
import themeSlice from './slices/themeSlice';
import { apiSlice } from './api/apiSlice';
import './api/authApi';
import { financeApi } from './api/financeApi';
import { maintenanceApi } from './api/maintenanceApi';
import { searchApi } from './api/searchApi';
import { costAnalysisApi } from './api/costAnalysisApi';
import { packingApi } from './api/packingApi';
import { deliveryCostApi } from './api/deliveryCostApi';
import { frequentAddressApi } from './api/frequentAddressApi';
// Import API endpoints to register them
import './api/authApi';
import './api/referencesApi';
import './api/cargoApi';
import './api/documentsApi';
import './api/documentRegistryApi';
import '../features/closingPackage/api/closingPackageApi';
import './api/locationsApi';
import './api/notificationsApi';
import './api/carrierAgreementsApi';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    notifications: notificationsSlice,
    ui: uiSlice,
    theme: themeSlice,
    api: apiSlice.reducer,
    financeApi: financeApi.reducer,
    maintenanceApi: maintenanceApi.reducer,
    searchApi: searchApi.reducer,
    costAnalysisApi: costAnalysisApi.reducer,
    packingApi: packingApi.reducer,
    deliveryCostApi: deliveryCostApi.reducer,
    frequentAddressApi: frequentAddressApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware, financeApi.middleware, maintenanceApi.middleware, searchApi.middleware, costAnalysisApi.middleware, packingApi.middleware, deliveryCostApi.middleware, frequentAddressApi.middleware),
});

// Enable listener behavior for the store
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 